module.exports = __webpack_public_path__ + "img/icon_img2.2e92d393.png";